module.exports = __webpack_public_path__ + "8fa40eb4fc07421440607d23cb484838.MP3";